import { TweenMax } from 'gsap';
import { enableBodyScroll } from 'body-scroll-lock';

/* eslint no-param-reassign: "error" */
function removeClass(el, className) {
  if (el.classList) el.classList.remove(className);
}

function hideMenuItems() {
  TweenMax.to('.menu__list li', 0.3, {
    opacity: 0
  });
}

export function closeMenu() {
  const body = document.querySelector('body');
  const menu = document.querySelector('[js-menu="menu"]');
  removeClass(body, 'isMenuOpen');
  hideMenuItems();
  enableBodyScroll(menu);
}

const eventHandler = () => {
  const el = document.querySelector('.js-menu-closer');
  if (el) el.addEventListener('click', closeMenu);
};

const menu = async () => eventHandler();

export default menu;
